import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

const createZoomMeeting = async ({
  topic,
  startTime,
  duration,
  timezone,
}: {
  topic: string;
  startTime: string;
  duration: number;
  timezone: string;
}) => {
  const res = await fetchOrchidAPI("/api/users/v1/zoom/create_meeting", {
    method: "POST",
    body: JSON.stringify({
      topic,
      start_time: startTime,
      duration,
      timezone,
    }),
  });

  if (!res.ok) {
    const responseText = await res.text();
    throw new Error(getErrorDetail(responseText));
  }

  return res.json();
};

export default createZoomMeeting;
